import { auditScheduleEdit, auditScheduleStore } from './request';
import iconList from '@/components/iconList.vue';
export default {
  components: {
    iconList
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
      required: true
    },
    isEdit: {
      default: false,
      required: true
    }
  },
  data() {
    return {
      addPlanForm: {
        name: '',
        iconName: ''
      },
      continueState: false
    };
  },
  computed: {
    ADD_RULES() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('进度名称'),
          trigger: 'blur'
        }, {
          message: '1-50' + this.$t('字符'),
          max: 50,
          min: 1
        }],
        iconName: [{
          required: true,
          message: this.$t('请选择') + this.$t('展示icon'),
          trigger: 'change'
        }]
      };
    }
  },
  watch: {
    visible(newV) {
      if (newV && !this.$props.isEdit) {
        this.emptyForm();
        this.resetForm();
      }
    },
    isEdit: {
      handler(newV) {
        if (newV.length) {
          this.addPlanForm.id = newV[0];
          this.addPlanForm.iconName = newV[1];
          this.addPlanForm.name = newV[2];
          // Object.assign(this.addPlanForm, newV);
        } else {
          this.emptyForm();
          this.resetForm();
        }
      },
      deep: true
    }
  },
  methods: {
    iconValue(value) {
      this.addPlanForm.iconName = value;
    },
    closeAddVisible(e) {
      this.$emit('cancel', e);
      this.emptyForm();
      this.resetForm();
    },
    saveAdd() {
      this.$refs.addPlanFormRef.validate(async valid => {
        if (valid) {
          if (this.$props.isEdit.length) {
            await auditScheduleEdit({
              scheduleName: this.addPlanForm.name,
              iconName: this.addPlanForm.iconName,
              id: this.addPlanForm.id
            });
            this.$emit('save', this.$props.isEdit, this.addPlanForm);
            this.closeAddVisible();
          } else {
            const {
              auditScheduleId
            } = await auditScheduleStore({
              scheduleName: this.addPlanForm.name,
              iconName: this.addPlanForm.iconName
            });
            this.addPlanForm.id = auditScheduleId;
            let updateObj = {};
            this.$emit('save', this.$props.isEdit, Object.assign(updateObj, this.addPlanForm));
            if (this.continueState) {
              this.emptyForm();
              this.resetForm();
            } else {
              this.closeAddVisible();
            }
          }
        }
      });
    },
    resetForm() {
      this.$nextTick(() => {
        this.$refs.addPlanFormRef.resetFields();
      });
    },
    emptyForm() {
      this.addPlanForm.name = '';
      this.addPlanForm.iconName = '';
      this.addPlanForm.id = '';
    },
    onContinueToAdd() {
      this.continueState = !this.continueState;
      //
    }
  }
};